import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { defaultTo, path, contains } from 'ramda';

import { apiGetEvent, apiRegisterForEvent } from '../../../api/event';
import { createMarkup, toCurrency } from '../../../util/helpers';
import { routes } from '../../index';
import { handleErrorBase, handleSuccessBase } from '../../../util/forms';
import { apiGetEventDiscount } from '../../../api/discount';

import Card from '../../../components/Card';
import StripeCheckout from '../../../components/StripeCheckout';
import DiscountForm from '../../../components/DiscountForm';
import magic from '../../../util/magic';

const isMemberOnlyEvent = (event) => event.type == magic.eventFpa || event.type == magic.eventVirtual;

class Event extends Component {
  static propTypes = {
    match: PropTypes.object,
    history: PropTypes.object,
    user: PropTypes.object,
  };

  state = {
    event: {},
    loaded: false,
    price: 0,
    discount: {},
  };

  componentDidMount() {
    const { match } = this.props;
    const selectedEventId = Number(match.params.id);
    this.fetchEvent(selectedEventId);
  }

  fetchEvent = (eventId) =>
    apiGetEvent(eventId)
      .then(({ data }) => {
        const isMember = path(['membership', 'valid'], this.props.user);
        const price = data.freeForMembers && isMember ? 0 : data.price;

        if (isMemberOnlyEvent(data) && !isMember) {
          this.props.history.push(routes.membership.root);
        }
        this.setState({ loaded: true, event: data, price });
      })
      .catch(() => this.setState({ loaded: true }));

  renderRow = (label, value, currency = false, url = false, html = false) => {
    if (value)
      return (
        <p>
          <strong>{label}:</strong>{' '}
          {currency ? (
            toCurrency(value)
          ) : url ? (
            <a href={value} target="_blank">
              {value}
            </a>
          ) : html ? (
            <span dangerouslySetInnerHTML={createMarkup(value)} />
          ) : (
            value
          )}
        </p>
      );
  };

  registerForEvent = (token, overrides = {}) => {
    const { history, match } = this.props;
    const { event, discount } = this.state;

    apiRegisterForEvent(event.categoryId, { token, discountCode: discount.code, ...overrides })
      .then(() => history.push(routes.events.paidBuilder(match.params.id)))
      .then(() => this.fetchEvent(event.categoryId))
      .then(() => handleSuccessBase())
      .catch(() => handleErrorBase());
  };

  render() {
    if (!this.state.loaded) return <noscript />;
    const { event, price, discount } = this.state;

    return (
      <Card className="container">
        <Card.Header>Event Details</Card.Header>
        <Card.Body>
          {this.renderRow('Name', event.name)}
          {this.renderRow('Description', event.description, false, false, true)}
          {this.renderRow('Date', event.date)}
          {this.renderRow('Price', price, true)}

          {event.registered ? (
            <Fragment>
              {!path(['extra', 'recording'], event) &&
                this.renderRow(
                  contains(event.type, [magic.eventFpa, magic.eventVirtual]) ? 'Click to attend' : 'Register here',
                  path(['extra', 'registration'], event),
                  false,
                  true,
                )}
              {this.renderRow('Recording', path(['extra', 'recording'], event), false, true)}
              {this.renderRow('Resource', path(['extra', 'resource1'], event), false, true)}
              {this.renderRow('Resource', path(['extra', 'resource2'], event), false, true)}
            </Fragment>
          ) : (
            <Fragment>
              {price > 0 && (
                <DiscountForm
                  discount={discount}
                  checkDiscount={(discountCode) => apiGetEventDiscount({ discountCode, eventId: event.id })}
                  update={(data) => {
                    this.setState({
                      price: data.payment / 100,
                      discount: defaultTo({}, data.discount),
                    });
                  }}
                />
              )}

              <div className="text-right">
                {price ? (
                  <StripeCheckout
                    name="Sage Financial Solutions"
                    description="Event Payment"
                    amount={Number(price)}
                    pay={(token, overrides = {}) => this.registerForEvent(token, overrides)}
                  />
                ) : (
                  <button className="btn btn-primary" onClick={() => this.registerForEvent()}>
                    Register
                  </button>
                )}
              </div>
            </Fragment>
          )}
        </Card.Body>
      </Card>
    );
  }
}

export default withRouter(Event);
